const PAGE = /** @type {const} */ ({
  AUTH_SOCIAL: '/auth/social/callback',
  COMMUNITY_LIST_SEO: '/communities-list',
  COMMUNITY_VIEW: '/community/[communityId]/[communitySlug]',
  COMMUNITY_VIEW_LANDING: '/community/[communityId]/[communitySlug]/landing',
  COMMUNITY_WIDGET: '/widget/communaute/[communityId]',
  CONNECT: '/connect',
  HOME: '/',
  INTENTIONS_WIDGET: '/widget/intentions/[widgetId]',
  INTENTIONS_WIDGET_FORM: '/widget/intentions/[widgetId]/form',
  RESET_PASSWORD: '/new-password',
  ERROR: '_error',
  ERROR_404: '/404',
  ERROR_410: '/410',
  ERROR_500: '/500',
})

const REVALIDATE = /** @type {const} */ ({
  NONE: 0,
  FIVE_SEC: 5,
  HALF_HOUR: 1800,
  ONE_HOUR: 3600,
  TWO_HOURS: 7200,
  ONE_DAY: 86400,
})

const STATIC_PAGES_REVALIDATE = {
  [PAGE.AUTH_SOCIAL]: REVALIDATE.NONE,
  [PAGE.ERROR_404]: REVALIDATE.NONE,
  [PAGE.ERROR_500]: REVALIDATE.NONE,
  [PAGE.COMMUNITY_LIST_SEO]: REVALIDATE.ONE_HOUR,
  [PAGE.COMMUNITY_VIEW_LANDING]: REVALIDATE.ONE_HOUR,
  [PAGE.COMMUNITY_VIEW]: REVALIDATE.ONE_HOUR,
  [PAGE.COMMUNITY_WIDGET]: REVALIDATE.TWO_HOURS,
  [PAGE.CONNECT]: REVALIDATE.NONE,
  [PAGE.HOME]: REVALIDATE.ONE_HOUR,
  [PAGE.INTENTIONS_WIDGET]: REVALIDATE.NONE,
  [PAGE.INTENTIONS_WIDGET_FORM]: REVALIDATE.HALF_HOUR,
  [PAGE.RESET_PASSWORD]: REVALIDATE.NONE,
}

module.exports = { PAGE, STATIC_PAGES_REVALIDATE }
